module.exports = __webpack_public_path__ + "fonts/CashSans-Extlight.7a8acc7.woff2";